import { toastUtils } from "../../../../utils/toast-utils";
import { cloud } from "@vitalsource/vstui/colors";

export const promotionToast = text => {
  return toastUtils.notify({
    type: "none",
    id: "promotion-toast",
    children: text,
    backgroundColor: cloud.getShade(3),
    borderColor: cloud.getShade(6),
    borderPosition: "left",
    horizontalPosition: "right"
    // maxWidth: 600
  });
};
